var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSend = function SvgSend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4132 3.31818L11.6735 15.6414C11.6082 15.8112 11.5071 15.9704 11.3701 16.1073C10.8466 16.6309 9.9978 16.6309 9.47423 16.1073C9.30183 15.9349 9.18621 15.7273 9.12739 15.5075L7.92524 11.0195C7.86639 10.7998 7.7508 10.5921 7.57837 10.4197C7.40596 10.2473 7.19827 10.1316 6.97858 10.0728L2.49051 8.87065C2.27078 8.81183 2.06312 8.69621 1.89072 8.52381C1.36715 8.00027 1.36715 7.15144 1.89072 6.6279C2.02763 6.49096 2.18683 6.38988 2.35661 6.32459L14.6799 1.58485C15.1592 1.40045 15.7233 1.50157 16.1099 1.8882C16.4965 2.27479 16.5976 2.83881 16.4132 3.31818Z",
    stroke: "#EEF1F4",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.82 7.17002L7.96997 10.02",
    stroke: "#EEF1F4",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgSend;